import { object, string } from 'yup';

import { buildMessageCallback } from '../../validation/utilities';
import '../../validation/custom-validators/phone-number-validator';
import { messages } from './messages';

export const PHONE_FIELD = 'phoneNumber';

export const buildPhoneCaptureSchema = (countryCode = 'US') =>
  object({
    [PHONE_FIELD]: string().required(buildMessageCallback(messages.phoneValidationError)).isValidPhoneNumberForCountry(countryCode),
  });
